import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';
import Content from 'components/ConfirmModal/Content';

const SelectStyled = styled.select`
  width: 100%;
  height: 35px;
  padding-right: 35px;
  padding-left: 5px;
  background: none;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid ${COLORS.line};
  color: #fff;
  font-size: 16px;
  line-height: 2;
  appearance: none;

  &:disabled {
    opacity: 0.4;
  }

  ${/* sc-sel */Content} & {
    border-color: ${COLORS.gray20};
  }
`;

export default SelectStyled;
